<template>
  <div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      width="1041px"
      @close="setDialogClosed"
      append-to-body
    >
      <el-container direction="vertical">
        <el-row v-for="(item, index) in list" :key="index">
          <el-descriptions :column="3" border style="margin-bottom: 10px">
            <el-descriptions-item label="项目">{{
              item.itemName
            }}</el-descriptions-item>
            <el-descriptions-item label="报告医生">{{
              item.doctorName
            }}</el-descriptions-item>
            <el-descriptions-item label="审核医生">{{
              item.reviewerName
            }}</el-descriptions-item>
          </el-descriptions>

          <el-table
            v-loading="listLoading"
            :data="list"
            border
            fit
            highlight-current-row
            style="width: 100%; margin-bottom: 30px"
          >
            <el-table-column width="200px" align="center" label="项目">
              <template slot-scope="scope">
                <span>{{ scope.row.itemName }}</span>
              </template>
            </el-table-column>

            <el-table-column width="400px" align="center" label="描述">
              <template slot-scope="scope">
                <span>{{ scope.row.examObserved }}</span>
              </template>
            </el-table-column>

            <el-table-column width="400px" align="center" label="结论">
              <template slot-scope="scope">
                <span>{{ scope.row.examResult }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="附件" width="100px">
              <template slot-scope="scope">
                <el-button
                  style="margin-left: 0px; align-self: center"
                  type="text"
                  @click="getItemDetail(scope.row)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </el-row>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { getExamReportDetail } from "@/api/health/ExamReportQuery";
import moment from "moment";

const server = "/cloudhealth-server-portal";

export default {
  data() {
    return {
      showDialog: false,
      title: "检查记录详情",
      list: null,
      listLoading: false
    };
  },
  methods: {
    // 编辑初始化页面内容
    async init(dataContext) {
      console.warn("dataContext: ",dataContext);
      this.showDialog = true;
      this.$nextTick(() => {
        this.getReportsList(dataContext.id);
        this.title = dataContext.reportName;
      });
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.showDialog = false;
    },
    getParsedTime(time) {
      if (time != null) {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }else{
        return '';
      }
    },
    getReportsList(itemId) {
      this.listLoading = true;
      getExamReportDetail(itemId).then((response) => {
        console.log(response);
        this.list = response.examItems;
        this.listLoading = false;
      });
    },
    // getItemDetail(row) {
    //   if (row.reportPath != null) {
    //     var value = row.reportPath;
    //     var reportPath = value.replace(/\\/g, "/");
    //     var path = "/healthinfo/zjhfile/file?path=" + reportPath;
    //     var url = "https://116.62.172.242:49080/" + server + path;
    //     window.open(url);
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
</style>